import React, { Component } from "react";
import { Row, Col } from 'reactstrap';
import AsyncSelect from 'react-select/async'
import RecorderWikiLayer from '../player-recorder/RecorderWikiLayer';
import PlayerWikiLayer from '../player-recorder/PlayerWikiLayer';
import UnpaidGeneralConsent from '../auth/UnpaidGeneralConsent';
import { FaExternalLinkSquareAlt } from "react-icons/fa";
import { loaderStyle } from '../../styles/modalStyles';
import Loader from 'react-loader-spinner';
import "../../styles/wiki.css";
import { Switch, FormGroup, FormControlLabel, createGenerateClassName } from '@material-ui/core';
import LocalMoviesRoundedIcon from '@material-ui/icons/Videocam';
import PlayCircleFilledRoundedIcon from '@material-ui/icons/PlayCircleFilledRounded';
import SlowMotionPlayRoundedIcon from '@material-ui/icons/SlowMotionVideoRounded';
import { connect } from 'react-redux';
import ApiClient from "../../api/ApiClient";
import ArrowLeftRoundedIcon from '@material-ui/icons/ArrowLeftRounded';
import Moment from 'moment';
import ViewBlocker from "../global/ViewBlocker";
import { isRecorderAvailable } from "../../services/video/videoUtils";
import { updateScore, populateStore, requestFailedModal } from '../../actions';
import { debounce } from "../../utils/utilMethods";
import { disambiguateSASURL } from "../../utils/urlSAS";

class WikiContainer extends Component {
    constructor(props) {
        super(props);
        this.apiClient = new ApiClient();
        this.state = {
            contentTopicsList: [],
            selectedCategories: { "All": true },
            stayOpen: false,
            isLoading: true,
            splashView: true,
            selectedOption: null,
            sentenceIndex: null,
            topicId: '',
            toggleWiki: false,
            title: '',
            articleTitle: '',
            clickTransition: true,
            sentence: '',
            contentTopicInfo: [],
            contentTopicSentences: [],
            contentTopicVideos: [],
            wikiVideoOptions: [],
            showWikiInfo: true,
            showVideoState: false,
            overwriteVideo: null,
            isInitialOverrideSelection: true,
            recordMode: false,
            loggedInUser: this.props.loggedInUser,
            totalRecordings: 0,
            canViewWiki: false,
            selectedTopicTextId: ''
        }
        window.document.addEventListener('tryClick', this.tryClick, false)
        window.document.addEventListener('sentenceClick', this.handleClick, false)

    }

    handleClick = (e) => {
        e.preventDefault();
        var sentence = unescape(e.detail);
        this.play(sentence);
    }


    selectStyles = {
        control: styles => ({ ...styles, minWidth: "300px", width: "100%", textAlign: 'left', zIndex: "99" })
    }

    readVideoMethods = {
        loadVideoCollection: async () => {

        }
    }

    isPainted = false;

    tryRecordingPaint() {
        try {
            if (this.state.wikiStructure && !this.isPainted && this.state.recordMode) {
                this.paintUserPreviouslyRecordedVideos(this.props.loggedInUser);
                this.isPainted = true
            }
        }
        catch (e) {
        }
    }

    componentDidMount() {
        if (window.location.href.includes("?targetArticle=")) {
            let articleId = window.location.href.split("?targetArticle=")[1].split("&targetName=")[0];
            let articleName = window.location.href.split("?targetArticle=")[1].split("&targetName=")[1]

            if (articleId) {
                this.handleChange({ value: articleId, term: articleName, message: "Needs Your Expertise" })
            }
        }

        this.apiClient.getJSON(this, "/getContentTopicSentences/options", "")
            .then(res => {

                if (res && res.status) {
                    this.setState({ isLoading: false });
                    const results = res.data.sort((a, b) => {
                        return (a.articleName.localeCompare(b.articleName));
                    });
                    this.setState({ wikiVideoOptions: results });
                }
                else if (res && res.httpServerError) {
                    // throw "Something Went Wrong"
                }
                this.setState({ isLoading: false });
            })
    }

    componentDidUpdate() {
        this.tryRecordingPaint();
    }

    loadNextSentenceVideo = async () => {

    }

    loadNextSentenceVideo = async () => {

    }

    unSetTextBackground(targetId) {
        const elem = window.document.getElementById(targetId);
        if (elem) {
            elem.style.background = "white";
            elem.removeAttribute("marked");
        }
    }

    setTextBackground(color, targetId, isTemp) {
        const elem = window.document.getElementById(targetId);
        if (!elem) {
            return;
        }
        if (isTemp) {
            if (!elem.hasAttribute("marked")) {
                elem.style.background = color;
            }
        }
        else {
            elem.setAttribute("marked", true);
            elem.style.background = color;
        }
    }

    genDefaultHighlightState = () => {
        const dhs = {
            current: null,
            previous: [],
            sentences: []
        }
        return dhs;
    }

    readHighlightState = this.genDefaultHighlightState();

    recordHighlightState = this.genDefaultHighlightState();

    doesPrevRecordingExist = (sectionIndex, sentenceIndex) => {
        try {
            let currentSectionRecordings = this.state.wikiStructure[sectionIndex].sentenceRecordings;
            sentenceIndex--;
            // End of section check
            if (sentenceIndex < 0) {
                sectionIndex--;
                sentenceIndex = this.state.wikiStructure[sectionIndex].sentenceRecordings.length - 1;
            }
            if (this.state.wikiStructure[sectionIndex].sentenceRecordings[sentenceIndex].recordings.length > 0) {
                return true;
            }
            else {
                this.setState({ currRecording: null, sentenceVideos: null })
                return false;
            }
        }
        catch (e) {
            this.setState({ currRecording: null, sentenceVideos: null })
            return false;
        }
    }

    doesNextRecordingExist = (sectionIndex, sentenceIndex) => {
        try {
            let currentSectionRecordings = this.state.wikiStructure[sectionIndex].sentenceRecordings;
            sentenceIndex++;
            // End of section check
            if (currentSectionRecordings.length === sentenceIndex) {
                sectionIndex++;
                sentenceIndex = 0;
            }

            if (this.state.wikiStructure[sectionIndex].sentenceRecordings[sentenceIndex].recordings.length > 0) {
                return true;
            }
            else {
                this.setState({ currRecording: null, sentenceVideos: null })
                return false;
            }
        }
        catch (e) {
            this.setState({ currRecording: null, sentenceVideos: null })
            return false;
        }
    }

    readNextVideo = async (sectionIndex, sentenceIndex) => {

        try {
            
            const self = this;;
            // Handle prev transition state inelegantly
            if (sentenceIndex === null) {
                sentenceIndex = this.state.wikiStructure[sectionIndex].sentenceRecordings.length - 1;
            }
            if (sectionIndex === undefined || sentenceIndex === undefined) {
                sectionIndex = self.readHighlightState.current.sectionIndex;
                sentenceIndex = self.readHighlightState.current.sentenceIndex;
                sentenceIndex++;
            }

            const prevSentenceIndex = sentenceIndex;
            //const prevSectionIndex = prevSectionIndex

            let sectionRecordings = self.state.wikiStructure[sectionIndex].sentenceRecordings;


            // // Check for next section if applicable
            if (sentenceIndex >= sectionRecordings.length) {
                sectionIndex = sectionIndex + 1;
                sentenceIndex = 0;
                sectionRecordings = self.state.wikiStructure[sectionIndex].sentenceRecordings;
                if (sectionRecordings.length < 1) {
                    return false;
                }
            }

            sectionRecordings = this.state.wikiStructure[sectionIndex].sentenceRecordings;
            self.readHighlightState.sentences = sectionRecordings
            self.setState({
                targetSentence: [sectionIndex, sentenceIndex],
                sentenceVideos: sectionRecordings[sentenceIndex].recordings.sort((a, b) => { return (a.user.userName.localeCompare(b.user.userName));})
            });

            const targetSection = self.state.wikiStructure[sectionIndex];

            // Ensure that system actually moving forward

            if (self.readHighlightState.current) {
                self.readHighlightState.previous.push(self.readHighlightState.current);
                self.setTextBackground("#F5FDFF", self.readHighlightState.current.sentenceId)
            }

            if (!self.readHighlightState.sentences[sentenceIndex]) {
                return false;
            }

            const sentState = {
                sectionIndex: sectionIndex,
                sentenceIndex: sentenceIndex,
                sentenceId: self.readHighlightState.sentences[sentenceIndex].id
            }

            self.readHighlightState.current = sentState;
            self.setTextBackground("#9ed4f7", self.readHighlightState.sentences[sentenceIndex].id);
            const bestSelectedIndex = await self.selectBestVideo(sectionRecordings, sentenceIndex, sectionIndex);

            await self.setState({
                sectionSentences: self.readHighlightState.sentences,
                sentenceIndex: sentenceIndex, sectionIndex: sectionIndex,
                currRecording: sectionRecordings[sentenceIndex].recordings[bestSelectedIndex]
            });
            if (sentenceIndex < self.state.wikiStructure[sectionIndex].sentenceRecordings.length) {
                return true
            }


            return false;
        }
        catch (e) {
        }
    }

    preferredUser = null;

    findUserWithMostConsecutiveRecordings(section, sentenceIndex, sectionIndex) {
        const self = this;
        let preferredUserId = null;
        let indexNextRecording = null;
        const userIndices = {};

        for (let si = section; si < section.length; si++) {
            const recordings = section[si].recordings
            for (let i = sentenceIndex; i < recordings.length; i++) {

                const userId = recordings[i].user.id;
                if (!userIndices.hasOwnProperty(userId)) {
                    userIndices[userId] =
                    {
                        continuity: [si],
                        continuityBrokenAtIndex: -1,

                    }
                }
                else if (userIndices[userId].continuityBrokenAtIndex === -1) {

                    const user = userIndices[userId];
                    const clen = user.continuity.length
                    // Check for continuity, scrap if not
                    if (si !== user.continuity[clen - 1] && user.continuity[clen - 1] !== si - 1) {
                        user.continuityBrokenAtIndex = user.continuity[clen - 1];
                    }
                    else {
                        if (si !== user.continuity[clen - 1]) {
                            user.continuity.push(si);
                        }
                    }
                }
            }
        }
        // Add current selection in case of no best options with lookahead
        if (Object.keys(userIndices).length === 0) {
            const recordings = section[sentenceIndex].recordings;
            const userId = recordings[0].user.id;
            userIndices[userId] =
            {
                continuity: [sentenceIndex],
                continuityBrokenAtIndex: -1,
            }
        }
        // Sort by latest continuity break (major), total continuity (minor)
        const sorted = Object.entries(userIndices).sort(([, a], [, b]) => {
            if (b.continuityBrokenAtIndex === a.continuityBrokenAtIndex) {
                if (a.continuity.length > b.continuity.length) {
                    return -1;
                }
                else {
                    return 1;
                }
            }
            else {
                if (a.continuityBrokenAtIndex === -1) {
                    return -1;
                }
                else if (b.continuityBrokenAtIndex === -1) {
                    return 1;
                }
                else if (a.continuityBrokenAtIndex < b.continuityBrokenAtIndex) {
                    return 1;
                }
                else {
                    return -1;
                }
            }
        });
        preferredUserId = sorted[0][0];
        section[sentenceIndex].recordings.forEach((item, sr) => {
            if (item.user.id === preferredUserId) {
                indexNextRecording = sr
            }
        });
        return {
            preferredUserId,
            indexNextRecording
        }
    }

    checkIfPreferredUserAvailable(sectionRecordings) {
        for (let i = 0; i < sectionRecordings.length; i++) {
            if (sectionRecordings[i].user.id === this.preferredUser) {
                return i;
            }
        }
    }

    selectBestVideo = async (section, sentenceIndex, sectionIndex) => {
        const self = this;
        let indexNextRecording;
        let preferredUserId = self.preferredUser;
        // First check if current preferred user is available
        if (this.preferredUser) {
            indexNextRecording = this.checkIfPreferredUserAvailable(section[sentenceIndex].recordings)
        }

        if (indexNextRecording === undefined || indexNextRecording === null) {
            // If not default to next best option
            const res = self.findUserWithMostConsecutiveRecordings(section, sentenceIndex, sectionIndex);
            indexNextRecording = res.indexNextRecording;
            preferredUserId = res.preferredUserId;
        }

        let videos = []
        // if (!self.state.sentenceVideos) {
        videos = self.state.wikiStructure[sectionIndex].sentenceRecordings[sentenceIndex].recordings;
        // }
        // else {
        //     videos = [...self.state.sentenceVideos]
        // }

        videos.forEach((vid) => {
            if (vid) {
                vid.isSelected = false;
            }
        })

        videos[indexNextRecording].isSelected = true;
        await this.setState({ sentenceVideos: videos })
        self.preferredUser = preferredUserId;
        return indexNextRecording;
    }

    targetSentence = []

    // For users that have recordings, avoid re-recording over quality, and find next unrecorded section
    identifyNextViableIndex = (sentenceIndex, sectionIndex) => {
        let self = this;
        let isViableVideoFound = false
        while (!isViableVideoFound) {
            const recs = self.state.wikiStructure[sectionIndex].sentenceRecordings[sentenceIndex].recordings;
            let userFoundInLoop = false;
            for (let i = 0; i < recs.length; i++) {
                if (recs[i].user.id === this.props.loggedInUser) {
                    userFoundInLoop = true;
                    break;
                }
            }
            if (!userFoundInLoop) {
                isViableVideoFound = true
                return { nextViableSentenceIndex: sentenceIndex, nextViableSectionIndex: sectionIndex }
            }
            sentenceIndex++
            if (sentenceIndex >= self.state.wikiStructure[sectionIndex].sentenceRecordingslength) {
                sectionIndex++
            }
            if (sectionIndex >= self.state.wikiStructure.length) {
                return { nextViableSentenceIndex: null, nextViableSectionIndex: null }
            }
        }
    }


    deSelectLine = () => {
        if (this.recordHighlightState.current) {
            this.setTextBackground("#EFFFEF", this.recordHighlightState.current.sentenceId);
            this.structureWikiHTML();
        }
    }

    // activateIsInitialOverrideSelection = async (val) => {
    //    await this.setState({ isInitialOverrideSelection: val })
    // }

    recordNextVideo = (sectionIndex, sentenceIndex, cancelOverride) => {
        try {
            const self = this;
            if (sectionIndex === -1) {
                sectionIndex = self.recordHighlightState.current.sectionIndex + 1;

                self.recordHighlightState.sentences = self.state.wikiStructure[sectionIndex].sentenceRecordings
            }
            if (sectionIndex === undefined || sentenceIndex === undefined) {
                sectionIndex = self.recordHighlightState.current.sectionIndex;
                sentenceIndex = self.recordHighlightState.current.sentenceIndex;
                sentenceIndex++;
            }

            // Increment might be a video that user already recorded, handle gracefully by looping until correct indices are found
            // if (!this.state.isInitialOverrideSelection) {
            //     const { nextViableSentenceIndex, nextViableSectionIndex } = this.identifyNextViableIndex(sentenceIndex, sectionIndex);
            //     if (nextViableSectionIndex === null) {
            //         return;
            //     }
            //     else {
            //         sectionIndex = nextViableSectionIndex
            //         sentenceIndex = nextViableSentenceIndex
            //     }
            // }
            // Subsequent overrides find next viable index

            const targetSection = self.state.wikiStructure[sectionIndex];
            if (self.recordHighlightState.current) {
                self.recordHighlightState.previous.push(self.recordHighlightState.current);
                self.setTextBackground("#EFFFEF", self.recordHighlightState.current.sentenceId)
            }
            const sentState = {
                sectionIndex: sectionIndex,
                sentenceIndex: sentenceIndex,
                sentenceId: self.recordHighlightState.sentences[sentenceIndex].id
            }
            self.recordHighlightState.current = sentState;
            self.setTextBackground("#0EBE0E", self.recordHighlightState.sentences[sentenceIndex].id);
            self.setState({ sectionSentences: self.recordHighlightState.sentences, sentenceIndex: sentenceIndex, sectionIndex: sectionIndex });
            this.structureWikiHTML();
        }
        catch (e) {
            // End of sections
        }
    }

    tryFindUserRecording(sectionRecordings) {
        const currentUID = this.props.loggedInUser;
        return sectionRecordings.find((rec) => {

            return rec.user.id === currentUID
        });
    }

    async clearRecordState() {
        await this.setState({ overwriteVideo: null, currRecording: null });
        await this.setState({ sectionSentences: null, sentenceIndex: null, sectionIndex: null });
    }

    beginSectionRecord = async (sectionIndex, sentenceIndex, cancelOverride) => {
        await this.clearRecordState();
        // Disambiguate if video is yours and change state to show that recording
        const sectionRecordings = this.state.wikiStructure[sectionIndex].sentenceRecordings[sentenceIndex].recordings;
        // Gives users ability to re-record existing videos
        const userRecording = this.tryFindUserRecording(sectionRecordings)
        if (userRecording && !cancelOverride) {
            // Camera shouldn't be on for override
            await this.setState({ overwriteVideo: userRecording, currRecording: userRecording });
        }
        else {
            await this.setState({ overwriteVideo: null });
        }

        this.recordNextVideo(sectionIndex, sentenceIndex, cancelOverride);
        this.initiateRecorder(true);
    }

    initiateRecorder = null;

    setRecorderRef = (ref) => {
        this.initiateRecorder = ref;
    }

    appendNewVideoData = (data) => {
        const self = this;
        const wikiStructure = self.state.wikiStructure;
        const { recording } = data;
        const updatedWikiStructure = [...wikiStructure]
        const section = updatedWikiStructure[recording.sectionIndex].sentenceRecordings[recording.sentenceIndex];
        const sentenceRecordings = section.recordings;
        let replaceTarget = null;
        for (let i = 0; i < sentenceRecordings.length; i++) {
            const target = sentenceRecordings[i];
            if (target.user.id === self.props.loggedInUser) {
                replaceTarget = target;
            }
        }
        // Handle initial recording
        if (replaceTarget === null) {
            replaceTarget = {};
            sentenceRecordings.push(replaceTarget)
        }
        // Handle re-record and initial recordings
        replaceTarget["convertedUrl"] = recording.blob;
        replaceTarget["user"] = recording.user
        replaceTarget["durationMS"] = recording.duration;
        replaceTarget["title"] = recording.title;
        this.setState({ wikiStructure: updatedWikiStructure })

    }

    selectSentence = async (sectionIndex, sentenceIndex, cancelOverride = false) => {

        // Manage UI in between clicks with lock
        // if(this.state.clickTransition) {
        //     await this.setState({clickTransition : false })
        //     // setTimeout(async () => {
        //         await this.setState({clickTransition : true })
        const targetSection = this.state.wikiStructure[sectionIndex];
        const sentences = targetSection.sentenceRecordings;
        
        
        if (!this.state.recordMode) {

            if (sentences.length < 1 || sentences[sentenceIndex].recordings < 1) {

                this.setState({ currRecording: null, sentenceVideos: null })
            }
            else {

                this.readHighlightState.sentences = sentences;
                this.readNextVideo(sectionIndex, sentenceIndex)
            }

        }

    }


    generateClassName() {
        return this.state.recordMode ? 'sentence-wrapper ' : 'read-sentence-wrapper ';
    }

    prevBack = null;



    switchColor(id) {
        const elem = document.getElementById(id);
        this.prevBack = elem.style.background;
        if (this.state.recordMode) {
            this.setTextBackground("#EFFFEF", id, true)
        }
        else {
            this.setTextBackground("#9ed4f7", id, true)
        }

    }


    switchColorRev(id) {
        this.setTextBackground(this.prevBack, id, true)
    }

    toggleWiki() {
        this.setState({ toggleWiki: !this.state.toggleWiki })
    }

    generateRecordingStatus(sentenceRecordings) {
        // const numberRecordings = sentenceRecordings.reduce((accum, rec) => {
        //     accum += (rec.recordings.length)
        //     return accum;
        // }, 0);
        // if (numberRecordings === 0) {
        //     return (
        //         // <div className="recordings-count">
        //         //     <svg className="recordings-count-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         //         <rect width="24" height="24" fill="white" />
        //         //         <path d="M14.0211 5.625H1.97895C0.88421 5.625 0 6.50921 0 7.60395V17.9618C0 19.0566 0.88421 19.9408 1.97895 19.9408H14.0211C15.1158 19.9408 16 19.0566 16 17.9618V7.60395C16 6.50921 15.1158 5.625 14.0211 5.625Z" fill="#697777" />
        //         //         <path d="M23.6627 7.85679C23.368 7.64626 23.0311 7.60416 22.6943 7.68837L17.2627 9.58311V16.6568L22.7364 18.5094C22.8627 18.5515 22.989 18.5515 23.1153 18.5515C23.3259 18.5515 23.4522 18.4673 23.6627 18.341C23.9574 18.1305 23.9995 17.7936 23.9995 17.4147V8.78311C23.9995 8.40416 23.9153 8.06732 23.6627 7.85679Z" fill="#697777" />
        //         //     </svg>
        //         //     <span className="recordings-count-label">Be the first to record</span>
        //         // </div>
        //     );
        // }
        // else {
        //     return (
        //         // <div className="recordings-count">
        //         //     <svg className="recordings-count-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         //         <rect width="24" height="24" fill="white" />
        //         //         <path d="M14.0211 5.625H1.97895C0.88421 5.625 0 6.50921 0 7.60395V17.9618C0 19.0566 0.88421 19.9408 1.97895 19.9408H14.0211C15.1158 19.9408 16 19.0566 16 17.9618V7.60395C16 6.50921 15.1158 5.625 14.0211 5.625Z" fill="#697777" />
        //         //         <path d="M23.6627 7.85679C23.368 7.64626 23.0311 7.60416 22.6943 7.68837L17.2627 9.58311V16.6568L22.7364 18.5094C22.8627 18.5515 22.989 18.5515 23.1153 18.5515C23.3259 18.5515 23.4522 18.4673 23.6627 18.341C23.9574 18.1305 23.9995 17.7936 23.9995 17.4147V8.78311C23.9995 8.40416 23.9153 8.06732 23.6627 7.85679Z" fill="#697777" />
        //         //     </svg>
        //         // </div>
        //     );
        // }
    }



    structureWikiHTML = () => {
        const pdotStyle = "position: absolute; margin-top: 6px; margin-left: 3px; margin-right: 5px; font-size: 32px; line-height: 12px;"
        const informationalStyle = `style="font-size: calc(0.75em * 0.875); font-weight:normal;"`
        const universalStyle = `font-size: calc(1.25em * 0.875); font-weight:normal; font-family: sans-serif !important;`
        const headerStyle = `font-size: calc(2em * 0.875); font-weight: bold;`

        let totalRecordings = 0;
        for (let i = 1; i < this.state.wikiStructure.length; i++) {
            for (let j = 0; j < this.state.wikiStructure[i].sentenceRecordings.length; j++) {
                totalRecordings += this.state.wikiStructure[i].sentenceRecordings[j].recordings.length
            }
        }
        this.setState({ totalRecordings: totalRecordings });

        //👋 Be the first to record
        // "⚡"
        const data = this.state.wikiStructure.map((header, sectionIndex) => {
            const sentences = header.sentenceRecordings.map((sentence, sentenceIndex) => {
                if (sentenceIndex === 0 && sectionIndex !== 0) {
                    const headerNode = (
                        <React.Fragment>
                            <div className="wiki-header-cont">
                                {sectionIndex !== 0 && <div className="sentence-header-title"

                                    id={sentence.id}
                                    onMouseOver={(id) => this.switchColor(sentence.id)}
                                    onMouseOut={(id) => this.switchColorRev(sentence.id)}
                                    onClick={() => this.selectSentence(sectionIndex, sentenceIndex)}

                                >{sectionIndex + '.0 ' + header.headerTitle}

                                    {!this.state.recordMode && (sentence.recordings.length > 0) && <span className="sentence-span"><PlayCircleFilledRoundedIcon style={{ fontSize: "18px" }} /></span>}
                                    {this.state.recordMode && (sentence.recordings.length > 0) && <span className="sentence-span"><LocalMoviesRoundedIcon style={{ fontSize: "18px" }} /></span>}
                                </div>
                                }


                            </div>

                        </React.Fragment>
                    )

                    return (
                        headerNode
                    )
                }
                else {
                    let s_id = sentence.id //sectionIndex + "-" + sentenceIndex;
                    return (
                        <div
                            id={s_id}
                            onMouseOver={(id) => this.switchColor(s_id)}
                            onMouseOut={(id) => this.switchColorRev(s_id)}
                            onClick={() => this.selectSentence(sectionIndex, sentenceIndex)}
                            className={this.generateClassName()}>
                            <p>
                                <span>
                                    <span>{sectionIndex + '.' + sentenceIndex  + ' '}</span>
                                    <span dangerouslySetInnerHTML={{ __html: sentence.sentenceText }} />
                                    {!this.state.recordMode && (sentence.recordings.length > 0) && <span className="sentence-span"><PlayCircleFilledRoundedIcon style={{ fontSize: "18px", marginBottom: "7px" }} /></span>}
                                    {this.state.recordMode && (sentence.recordings.length > 0) && <span className="sentence-span"><LocalMoviesRoundedIcon style={{ fontSize: "18px", marginBottom: "7px" }} /></span>}
                                    {/* { (sentence.recordings.length == 0) && <span className="sentence-span"><PlayCircleFilledRoundedIcon style={{fontSize: "18px"}} /></span> } */}
                                </span>
                            </p>
                            {/* <div className="recording-indicator">{sentence.recordings.length} recordings</div> */}
                        </div>
                    )
                }
            });
            return (
                <div className="wiki-section-box">
                    {sectionIndex === 0 && <div className="wiki-header-top" >{sentences[0]} </div>}
                    {sectionIndex !== 0 && <div className="wiki-header-outer">{sentences[0]} </div>}
                    <div>{sentences.slice(1)}</div>
                </div>
            )
        })
        this.setState({ formattedSentences: data });
    }

    paintSentence(sentenceId) {
        this.setTextBackground("#EFFFEF", sentenceId)
    }

    // Ensure that users sees where they themselves have already recorded
    paintUserPreviouslyRecordedVideos(uid) {
        let totalRecordings = 0;
        for (let i = 0; i < this.state.wikiStructure.length; i++) {
            for (let j = 0; j < this.state.wikiStructure[i].sentenceRecordings.length; j++) {
                totalRecordings += this.state.wikiStructure[i].sentenceRecordings[j].recordings.length
                for (let k = 0; k < this.state.wikiStructure[i].sentenceRecordings[j].recordings.length; k++) {
                    const rec = this.state.wikiStructure[i].sentenceRecordings[j].recordings[k]
                    if (uid === rec.user.id) {
                        const sid = this.state.wikiStructure[i].sentenceRecordings[j].id
                        this.paintSentence(sid)
                        break;
                    }
                }
            }
        }
        this.setState({ totalRecordings: totalRecordings });
    }

    componentWillReceiveProps(props) {
        this.setState({ loggedInUser: props.loggedInUser });
    }

    // Debounce input
    debounceInitTime;
    debounceSearchText = debounce();

    // searchForArticles = (query) => {
    //     if (query.length > 0) {
    //         return this.debounceSearchText(query, this.topicOptions);
    //     }
    // }

    handleChange = selectedOption => {
        this.clearPrevState();
        this.setState({ selectedOption });
        this.setState({ topicId: selectedOption.value });
        this.getContentTopicInfo(selectedOption.value);
        if (this.refs.wikiframe) {
            this.state.url = null;
            this.refs.wikiframe.srcdoc = '<p>Loading...</p>'
        }

    };
    // + "*"
    topicOptions = inputValue => {
        if (inputValue.length < 1) return [];
        return new Promise(resolve => {
            this.apiClient.getJSON(this, '/getContentTopicsList', '?search=' + inputValue).then((res) => {
                if (res && res.status) {
                    var contentTopics = [];
                    if (res.data) {
                        res.data.forEach(contentTopic => {
                            contentTopics.push({ value: contentTopic.articleId, label: contentTopic.articleName })
                        });
                        this.setState({ contentTopicsList: contentTopics.slice() });
                        resolve(contentTopics.slice());
                    }

                }
                else if (res && res.httpServerError) {
                    // throw "Something Went Wrong"
                }
            });
        });
    }

    getContentTopicInfo = async (topicId) => {
        this.setState({ showVideoState: true, selectedTopicTextId: "bla", showWikiInfo: false });
        this.setState({ isLoading: true, splashView: false });

        this.apiClient.getJSON(this, '/getContentTopicSentences', '?topicId=' + topicId).then(async (res) => {
            if (res && res.status) {
                // if (res.wikiStructure && res.wikiStructure[0]) {
                //     res.wikiStructure[0].sentenceRecordings.unshift({  });
                // }
                
                await this.setState({
                    articleTitle: res.data.title,
                    wikiContent: res.data.enhancedHTML,
                    wikiStructure: res.data.wikiStructure,
                    articleId: res.data.articleId, title: res.data.title,
                    url: "https://en.wikipedia.org/wiki/" + res.data.title.replace(' ', '_'),
                    contentTopicSentences: res.data.sentences,
                    contentTopicInfo: res.data.page,
                    showWikiInfo: false
                });
                this.structureWikiHTML();
                this.setState({ showVideoState: true, selectedTopicTextId: topicId });

                this.setState({ isLoading: false });
            }
            else if (res && res.httpServerError) {
                // throw "Something Went Wrong"
            }
        });
    }

    getSelectedTextInfo = (selectedTextId) => {
        this.apiClient.getJSON(this, '/getContentTopicVideos', '?topicId=' + this.state.articleId + "&title=" + this.state.title + "&sentence=" + selectedTextId.trim()).then((res) => {
            if (res && res.status) {
                this.setState({
                    contentTopicVideos: res.data.videos,
                });
                this.setState({ showVideoState: true, selectedTopicTextId: selectedTextId });
            }
            else if (res && res.httpServerError) {
                // throw "Something Went Wrong"
                //fyddid
                //this.setState({ showVideoState: false, selectedTopicTextId: selectedTextId });
            }
        });
    }

    clearHighlights(target) {
        target.previous.forEach((rhs) => {
            this.unSetTextBackground(rhs.sentenceId)
        })
        if (target.current) {
            this.unSetTextBackground(target.current.sentenceId);
        }
    }

    resetHighlights() {
        this.clearHighlights(this.readHighlightState);
        this.clearHighlights(this.recordHighlightState);
        this.readHighlightState = this.genDefaultHighlightState();
        this.recordHighlightState = this.genDefaultHighlightState();
    }

    clearPrevState = async () => {
        this.setState({
            overwriteVideo: null,
            currRecording: null,
            currVideo: null,
            sentenceVideos: null,
            stayOpen: false,
            isLoading: false,
            sentenceIndex: null,
            showVideoState: false,
            overwriteVideo: null,
            isInitialOverrideSelection: true,
        })
    }

    switchSelectedUser = (uid) => {
        this.preferredUser = uid;
    }

    updateSelectedVideoState = async (targetIndex) => {
        const self = this;
        const videos = [...self.state.sentenceVideos]
        videos.forEach((vid) => {
            vid.isSelected = false;
        })
        videos[targetIndex].isSelected = true;
        await this.setState({ sentenceVideos: videos })
    }

    switchVideo = async (vid, vi) => {
        this.updateSelectedVideoState(vi);
        this.switchSelectedUser(vid.user.id);
        const update = { ...vid }
        update.isSelected = false
        this.setState({ currRecording: update });
    }

    backToLanding = () => {
        this.setState({ splashView: true })
    }

    setValue = (val) => {
        const selectedCategories = { ...this.state.selectedCategories };
        if (selectedCategories[val]) {
            delete selectedCategories[val]
        } else {
            selectedCategories[val] = true;
        }
        this.setState({ selectedCategories: selectedCategories })
    }

    transitionNewTab = (vid) => {
        window.open(process.env.PUBLIC_URL + "/wiki?targetArticle=" + vid.articleId + "&targetName=" + vid.articleName, '');
    }

    categories = ["Science", "Geography", "Mathematics", "Technology", "Medicine"] // ["Deaf Culture", "Food", "Geography", "History", "Politics", "Entertainment", "Technology", "Art", "Books", "Military", "Mathematics", "Philosophy", "Business", "Science", "Medicine", "Religion", "Sports"]
    render() {
        const { stayOpen } = this.state;
        let self = this;
        document.title = 'Wiki - The ASL Data Community';
        // if (((self.state.wikiVideoOptions && self.state.wikiVideoOptions.length === 0) || !self.state.wikiVideoOptions) && !self.state.isLoading) {
        //     return (
        //         <div className="login-prompt">Please sign in to access the Wiki view.</div>
        //     )
        // }

        if (this.state.isLoading) {
            return (
                <div style={loaderStyle}>
                    <Loader
                        type="ThreeDots"
                        color="#00BFFF"
                        height={100}
                        width={100}
                    />
                    Loading Article
                </div>
            )
        }

        // if (this.state.canViewWiki === false) {
        //     return (
        //         <div className="login-prompt consent">
        //             <div>Before we can get you setup for the Wiki, please read the terms of consent and accept or deny</div>
        //             <UnpaidGeneralConsent></UnpaidGeneralConsent>
        //             <div className="accept-reject-consent-box">
        //                 <div className="record-btn" onClick={() => this.acceptConsent()} style={{marginRight: "25px", height: "25px", cursor: "pointer"}}>Accept</div>
        //                 <div className="record-btn" onClick={() => window.location = process.env.PUBLIC_URL +"/info" } style={{height: "25px"}}>Reject</div>
        //             </div>
        //         </div>
        //     )
        // }


        let titles = this.state.wikiVideoOptions.map((vid) => {

            let isVisible = this.state.selectedCategories[vid.categories4[0]]
            // vid.categories4.forEach((vc) => {
            //     if (this.state.selectedCategories[vc]) {
            //         isVisible = true;
            //     }
            // });

            if (isVisible || this.state.selectedCategories["All"]) {
                return (
                    <div className="article-display-row" onClick={() => this.transitionNewTab(vid)}>
                        <div className="wiki-display-col-1">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "10px" }}>
                                <path d="M5.5 2C4.11929 2 3 3.11929 3 4.5V19.5C3 20.8807 4.11929 22 5.5 22H12.8096C12.3832 21.5557 12.0194 21.051 11.7322 20.5H5.5C4.94772 20.5 4.5 20.0523 4.5 19.5H11.3135C11.159 19.0218 11.0585 18.5195 11.0189 18H4.5V4.5C4.5 3.94772 4.94772 3.5 5.5 3.5H17C17.5523 3.5 18 3.94772 18 4.5V11.0189C18.5195 11.0585 19.0218 11.159 19.5 11.3135V4.5C19.5 3.11929 18.3807 2 17 2H5.5ZM23 17.5C23 14.4624 20.5376 12 17.5 12C14.4624 12 12 14.4624 12 17.5C12 20.5376 14.4624 23 17.5 23C20.5376 23 23 20.5376 23 17.5ZM16.9138 15.097L19.7203 16.9373C19.8073 16.9933 19.8757 17.0677 19.9254 17.1604C19.9751 17.251 20 17.3502 20 17.458C20 17.5614 19.9762 17.6606 19.9285 17.7555C19.8809 17.8504 19.8146 17.9258 19.7296 17.9819L16.9231 19.8965C16.8713 19.931 16.8184 19.9569 16.7646 19.9741C16.7128 19.9914 16.6568 20 16.5967 20C16.518 20 16.4424 19.9838 16.3699 19.9515C16.2973 19.917 16.2331 19.8717 16.1772 19.8157C16.1233 19.7574 16.0798 19.6906 16.0466 19.6151C16.0155 19.5397 16 19.461 16 19.379V15.621C16 15.5369 16.0155 15.4571 16.0466 15.3816C16.0798 15.3062 16.1233 15.2404 16.1772 15.1843C16.231 15.1283 16.2942 15.0841 16.3667 15.0517C16.4393 15.0172 16.5159 15 16.5967 15C16.7128 15 16.8184 15.0323 16.9138 15.097ZM6 6C6 5.44772 6.44772 5 7 5H15C15.5523 5 16 5.44772 16 6V8C16 8.55228 15.5523 9 15 9H7C6.44772 9 6 8.55228 6 8V6ZM7.5 7.5H14.5V6.5H7.5V7.5Z" fill="#6E6E6E" />
                            </svg>

                            {vid.articleName}
                        </div>
                        <div className="wiki-display-col-2">
                            {vid.categories4[0]}
                        </div>
                        <div className="wiki-display-col-3">
                                <span className="recordings-present">{vid.sentenceCount + " sentences"}</span>
                        </div>
                        <div className="wiki-display-col-4">
                            {/* <button className="record-btn" style={{ marginBottom: "5px" }}>Record</button> */}
                        </div>
                    </div>
                );
            }
            else {
                return (null);
            }
        });

        // 
        let categorySelections = this.categories.map((cat) => {
            return (
                <React.Fragment>
                    {(cat === "All") && <div className="category-display-row">
                        <label for={cat}>
                            <input onChange={() => this.setValue(cat)} checked={this.state.selectedCategories["All"]}
                                className="chck" type="checkbox" id={cat} />
                            {cat}</label>
                    </div >}

                    {(cat !== "All") && <div className="category-display-row">
                        <label for={cat}>
                            <input onChange={() => this.setValue(cat)} checked={this.state.selectedCategories[cat]}
                                className="chck" type="checkbox" id={cat} />

                            {cat}</label>
                    </div >}

                </React.Fragment>
            )
        });



        if (this.state.splashView) {

            return (
                <React.Fragment>
                    <div className="wiki-top-fixed-back"></div>
                    <div className="wiki-top-fixed-div">
                        <video className="explainer-video" autoPlay muted src={process.env.REACT_APP_SERVER_URL + "/getBlob?containerName=svgs&blobName=PXL_20210528_203311254.mp4"}
                            controls loop preload="auto" type="video/mp4">
                        </video>
                        <div className="explainer-header">
                            <div className="explainer-header-title"><h3 role="heading">Improving access to articles in American Sign Language (ASL)</h3></div>
                            <div className="explainer-header-description">
                                Articles online are often only available in English. We enable ASL signers to record and share ASL versions of articles. These recordings make information accessible to people who prefer ASL, while also contributing to an English-to-ASL dataset, which can be used for research and development of technologies to better support ASL signers.
                            </div>
                        </div>
                    </div>
                    <ViewBlocker history={this.props.history} onClick={() => this.setState({ showBlocker: false })} isDisplayBlocked={this.state.showBlocker}></ViewBlocker>
                    <div className="center-wrapper-wiki">
                        <div className="center-column">
                            <div className="categories-col">
                                {/* <div className="wiki-search">
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        onChange={this.handleChange}
                                        loadOptions={this.topicOptions}
                                        styles={this.selectStyles} />
                                </div> */}
                                <div className="featured-lbl">
                                    Featured Categories
                                </div>
                                <div className="category-display-row">
                                    <label for="All">
                                        <input className="chck"
                                            onChange={() => this.setValue("All")} checked={this.state.selectedCategories["All"]} type="checkbox" id="All" />All</label>
                                </div>
                                {categorySelections}
                            </div>
                            <div className="listing-col">
                                <div className="wiki-header">
                                    <div className="wiki-display-col-1">
                                        <div>Article</div>
                                    </div>
                                    <div className="wiki-display-col-2">
                                        <div>Category</div>
                                    </div>
                                    <div className="wiki-display-col-3">
                                        <div># Sentences</div>
                                    </div>

                                </div>
                                <div style={{ marginBottom: "100px" }}>
                                    {titles}
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment >
            )
        }
        // <div className="wiki-articles-box">
        //         <div className="wiki-articles-top-row">
        //             <div className="wiki-articles-header">
        //                 Select from the articles below or search for one
        //             </div>
        //             <div className="wiki-search">
        //                 <AsyncSelect 
        //                     cacheOptions
        //                     defaultOptions
        //                     onChange={this.handleChange}
        //                     loadOptions={this.topicOptions}
        //                     styles={this.selectStyles} />
        //             </div>
        //         </div>
        //         <div className="suggested-list">
        //                 {suggestedSearches.map((val) => {
        //                     return <div className="suggested-list-item">
        //                         <div onClick={() => this.handleChange(val)} className="main-content">{val.term}</div>

        //                     </div>
        //                 })}
        //             </div>
        //     </div> 






        let input;


        return (
            <React.Fragment>

                {this.state.showBlocker && <ViewBlocker history={this.props.history} isDisplayBlocked={true}></ViewBlocker>}

                <div role="main" className="mainFrame">
                    <div className="wiki-select-row" style={{ width: "530px", position: "fixed" }}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                            <button className="wiki-return" onClick={() => this.backToLanding()}>
                                <ArrowLeftRoundedIcon style={{ fontSize: "20px", marginBottom: "2px" }} /> <span style={{ marginTop: "3px" }} >Wiki Home </span>
                            </button>
                            <span className="having-trouble" style={{ marginLeft: "15px" }}>
                                <a target="_blank" href="https://forms.office.com/Pages/ResponsePage.aspx?id=v4j5cvGGr0GRqy180BHbRx1qYFM3N0FCo6HgdDr2DB1UMkJZRTFWSzJJR0VNSjBYU05CQldRTldWWi4u">Having trouble?</a>
                            </span>
                        </div>
                        {/* <div>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        onChange={this.handleChange}
                                        loadOptions={this.topicOptions}
                                        styles={this.selectStyles} />
                                </div> */}

                        {/* {this.props.loggedInUser && <div className="mode-toggle" onClick={this.toggleMode}>


                            {!this.state.recordMode &&

                                <svg width="219" height="30" viewBox="0 0 219 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="90" width="125" height="30" rx="15" fill="#F2F2F2" />
                                    <path d="M126.639 21H125.174L123.417 18.0557C123.255 17.7822 123.099 17.5503 122.948 17.3599C122.796 17.1646 122.64 17.0059 122.479 16.8838C122.323 16.7617 122.152 16.6738 121.966 16.6201C121.786 16.5615 121.581 16.5322 121.351 16.5322H120.34V21H119.11V10.4971H122.245C122.704 10.4971 123.126 10.5557 123.512 10.6729C123.902 10.7852 124.239 10.9585 124.523 11.1929C124.811 11.4272 125.035 11.7202 125.196 12.0718C125.358 12.4185 125.438 12.8262 125.438 13.2949C125.438 13.6611 125.382 13.998 125.27 14.3057C125.162 14.6084 125.006 14.8794 124.801 15.1187C124.601 15.3579 124.357 15.563 124.068 15.7339C123.785 15.8999 123.465 16.0293 123.109 16.1221V16.1514C123.285 16.2295 123.436 16.3198 123.563 16.4224C123.695 16.52 123.819 16.6372 123.937 16.7739C124.054 16.9106 124.169 17.0669 124.281 17.2427C124.398 17.4136 124.527 17.6138 124.669 17.8433L126.639 21ZM120.34 11.6104V15.4189H122.01C122.318 15.4189 122.601 15.3726 122.86 15.2798C123.124 15.187 123.351 15.0552 123.541 14.8843C123.732 14.7085 123.88 14.4961 123.988 14.2471C124.095 13.9932 124.149 13.71 124.149 13.3975C124.149 12.8359 123.966 12.3989 123.6 12.0864C123.238 11.769 122.713 11.6104 122.025 11.6104H120.34ZM133.277 17.5503H127.981C128.001 18.3853 128.225 19.0298 128.655 19.4839C129.085 19.938 129.676 20.165 130.428 20.165C131.272 20.165 132.049 19.8867 132.757 19.3301V20.458C132.098 20.9365 131.226 21.1758 130.142 21.1758C129.082 21.1758 128.25 20.8364 127.644 20.1577C127.039 19.4741 126.736 18.5146 126.736 17.2793C126.736 16.1123 127.066 15.1626 127.725 14.4302C128.389 13.6929 129.212 13.3242 130.193 13.3242C131.175 13.3242 131.934 13.6416 132.471 14.2764C133.008 14.9111 133.277 15.7925 133.277 16.9204V17.5503ZM132.046 16.5322C132.041 15.8389 131.873 15.2993 131.541 14.9136C131.214 14.5278 130.757 14.335 130.171 14.335C129.605 14.335 129.124 14.5376 128.728 14.9429C128.333 15.3481 128.089 15.8779 127.996 16.5322H132.046ZM139.973 20.6558C139.397 21.0024 138.713 21.1758 137.922 21.1758C136.853 21.1758 135.988 20.8291 135.329 20.1357C134.675 19.4375 134.348 18.5342 134.348 17.4258C134.348 16.1904 134.702 15.1992 135.41 14.4521C136.118 13.7002 137.063 13.3242 138.244 13.3242C138.903 13.3242 139.484 13.4463 139.987 13.6904V14.9209C139.431 14.5303 138.835 14.335 138.2 14.335C137.434 14.335 136.804 14.6108 136.311 15.1626C135.822 15.7095 135.578 16.4297 135.578 17.3232C135.578 18.2021 135.808 18.8955 136.267 19.4033C136.731 19.9111 137.351 20.165 138.127 20.165C138.781 20.165 139.397 19.9478 139.973 19.5132V20.6558ZM144.684 21.1758C143.576 21.1758 142.689 20.8267 142.025 20.1284C141.366 19.4253 141.036 18.4951 141.036 17.3379C141.036 16.0781 141.381 15.0942 142.069 14.3862C142.758 13.6782 143.688 13.3242 144.86 13.3242C145.978 13.3242 146.849 13.6685 147.474 14.3569C148.104 15.0454 148.419 16 148.419 17.2207C148.419 18.417 148.08 19.3765 147.401 20.0991C146.727 20.8169 145.822 21.1758 144.684 21.1758ZM144.772 14.335C144 14.335 143.39 14.5986 142.941 15.126C142.492 15.6484 142.267 16.3711 142.267 17.2939C142.267 18.1826 142.494 18.8833 142.948 19.396C143.402 19.9087 144.01 20.165 144.772 20.165C145.548 20.165 146.144 19.9136 146.559 19.4106C146.979 18.9077 147.189 18.1924 147.189 17.2646C147.189 16.3271 146.979 15.6045 146.559 15.0967C146.144 14.5889 145.548 14.335 144.772 14.335ZM154.009 14.7158C153.799 14.5547 153.497 14.4741 153.101 14.4741C152.588 14.4741 152.159 14.7158 151.812 15.1992C151.47 15.6826 151.299 16.3418 151.299 17.1768V21H150.098V13.5H151.299V15.0454H151.329C151.5 14.5181 151.761 14.1079 152.112 13.8149C152.464 13.5171 152.857 13.3682 153.292 13.3682C153.604 13.3682 153.843 13.4023 154.009 13.4707V14.7158ZM161.474 21H160.273V19.7256H160.244C159.687 20.6924 158.828 21.1758 157.666 21.1758C156.723 21.1758 155.969 20.8413 155.403 20.1724C154.841 19.4985 154.56 18.583 154.56 17.4258C154.56 16.1855 154.873 15.1919 155.498 14.4448C156.123 13.6978 156.955 13.3242 157.995 13.3242C159.026 13.3242 159.775 13.7295 160.244 14.54H160.273V9.89648H161.474V21ZM160.273 17.6089V16.5029C160.273 15.8975 160.073 15.3848 159.673 14.9648C159.272 14.5449 158.764 14.335 158.149 14.335C157.417 14.335 156.841 14.6035 156.421 15.1406C156.001 15.6777 155.791 16.4199 155.791 17.3672C155.791 18.2314 155.991 18.915 156.391 19.418C156.797 19.916 157.339 20.165 158.017 20.165C158.686 20.165 159.228 19.9233 159.643 19.4399C160.063 18.9565 160.273 18.3462 160.273 17.6089ZM178.192 21H176.991V16.6934C176.991 15.8633 176.861 15.2627 176.602 14.8916C176.348 14.5205 175.919 14.335 175.313 14.335C174.801 14.335 174.364 14.5693 174.002 15.0381C173.646 15.5068 173.468 16.0684 173.468 16.7227V21H172.266V16.5469C172.266 15.0723 171.698 14.335 170.56 14.335C170.033 14.335 169.598 14.5571 169.256 15.0015C168.914 15.4409 168.743 16.0146 168.743 16.7227V21H167.542V13.5H168.743V14.6865H168.773C169.305 13.7783 170.081 13.3242 171.102 13.3242C171.615 13.3242 172.061 13.4683 172.442 13.7563C172.823 14.0396 173.084 14.4131 173.226 14.877C173.783 13.8418 174.613 13.3242 175.716 13.3242C177.366 13.3242 178.192 14.3423 178.192 16.3784V21ZM183.357 21.1758C182.249 21.1758 181.362 20.8267 180.698 20.1284C180.039 19.4253 179.709 18.4951 179.709 17.3379C179.709 16.0781 180.054 15.0942 180.742 14.3862C181.431 13.6782 182.361 13.3242 183.533 13.3242C184.651 13.3242 185.522 13.6685 186.147 14.3569C186.777 15.0454 187.092 16 187.092 17.2207C187.092 18.417 186.753 19.3765 186.074 20.0991C185.4 20.8169 184.495 21.1758 183.357 21.1758ZM183.445 14.335C182.673 14.335 182.063 14.5986 181.614 15.126C181.165 15.6484 180.94 16.3711 180.94 17.2939C180.94 18.1826 181.167 18.8833 181.621 19.396C182.075 19.9087 182.683 20.165 183.445 20.165C184.221 20.165 184.817 19.9136 185.232 19.4106C185.652 18.9077 185.862 18.1924 185.862 17.2646C185.862 16.3271 185.652 15.6045 185.232 15.0967C184.817 14.5889 184.221 14.335 183.445 14.335ZM195.173 21H193.971V19.7256H193.942C193.386 20.6924 192.526 21.1758 191.364 21.1758C190.422 21.1758 189.667 20.8413 189.101 20.1724C188.539 19.4985 188.259 18.583 188.259 17.4258C188.259 16.1855 188.571 15.1919 189.196 14.4448C189.821 13.6978 190.654 13.3242 191.694 13.3242C192.724 13.3242 193.473 13.7295 193.942 14.54H193.971V9.89648H195.173V21ZM193.971 17.6089V16.5029C193.971 15.8975 193.771 15.3848 193.371 14.9648C192.97 14.5449 192.463 14.335 191.847 14.335C191.115 14.335 190.539 14.6035 190.119 15.1406C189.699 15.6777 189.489 16.4199 189.489 17.3672C189.489 18.2314 189.689 18.915 190.09 19.418C190.495 19.916 191.037 20.165 191.716 20.165C192.385 20.165 192.927 19.9233 193.342 19.4399C193.761 18.9565 193.971 18.3462 193.971 17.6089ZM203.392 17.5503H198.097C198.116 18.3853 198.341 19.0298 198.771 19.4839C199.2 19.938 199.791 20.165 200.543 20.165C201.388 20.165 202.164 19.8867 202.872 19.3301V20.458C202.213 20.9365 201.341 21.1758 200.257 21.1758C199.198 21.1758 198.365 20.8364 197.76 20.1577C197.154 19.4741 196.852 18.5146 196.852 17.2793C196.852 16.1123 197.181 15.1626 197.84 14.4302C198.504 13.6929 199.327 13.3242 200.309 13.3242C201.29 13.3242 202.049 13.6416 202.586 14.2764C203.124 14.9111 203.392 15.7925 203.392 16.9204V17.5503ZM202.162 16.5322C202.157 15.8389 201.988 15.2993 201.656 14.9136C201.329 14.5278 200.873 14.335 200.287 14.335C199.72 14.335 199.239 14.5376 198.844 14.9429C198.448 15.3481 198.204 15.8779 198.111 16.5322H202.162Z" fill="#666666" />
                                    <rect width="106" height="30" rx="15" fill="#A850FF" />
                                    <path d="M24.4116 21H22.3755L20.6982 18.1875C20.5469 17.9287 20.3979 17.709 20.2515 17.5283C20.1099 17.3428 19.9634 17.1914 19.812 17.0742C19.6655 16.957 19.5044 16.8716 19.3286 16.8179C19.1528 16.7642 18.9551 16.7373 18.7354 16.7373H18.0322V21H16.2964V10.4971H19.7534C20.2466 10.4971 20.7007 10.5557 21.1157 10.6729C21.5308 10.79 21.8921 10.9683 22.1997 11.2075C22.5073 11.4419 22.7466 11.7373 22.9175 12.0938C23.0933 12.4453 23.1812 12.8579 23.1812 13.3315C23.1812 13.7026 23.125 14.0444 23.0127 14.3569C22.9053 14.6646 22.749 14.9404 22.5439 15.1846C22.3438 15.4238 22.0996 15.6289 21.8115 15.7998C21.5283 15.9707 21.2085 16.1025 20.8521 16.1953V16.2246C21.0425 16.332 21.2085 16.4517 21.3501 16.5835C21.4917 16.7104 21.626 16.8423 21.7529 16.979C21.8799 17.1157 22.0044 17.272 22.1265 17.4478C22.2534 17.6187 22.3926 17.8188 22.5439 18.0483L24.4116 21ZM18.0322 11.9106V15.3237H19.4824C19.751 15.3237 19.9976 15.2822 20.2222 15.1992C20.4517 15.1162 20.6494 14.9966 20.8154 14.8403C20.9814 14.6841 21.1108 14.4937 21.2036 14.269C21.2964 14.0444 21.3428 13.793 21.3428 13.5146C21.3428 13.0117 21.1841 12.6187 20.8667 12.3354C20.5493 12.0522 20.0928 11.9106 19.4971 11.9106H18.0322ZM31.1663 17.7114H26.0539C26.0735 18.4048 26.2859 18.9395 26.6912 19.3154C27.1013 19.6914 27.6628 19.8794 28.3757 19.8794C29.1765 19.8794 29.9114 19.6401 30.5803 19.1616V20.5312C29.8967 20.9609 28.9934 21.1758 27.8704 21.1758C26.7668 21.1758 25.9001 20.8364 25.2703 20.1577C24.6453 19.4741 24.3328 18.5146 24.3328 17.2793C24.3328 16.1123 24.677 15.1626 25.3655 14.4302C26.0588 13.6929 26.9182 13.3242 27.9436 13.3242C28.969 13.3242 29.7624 13.6538 30.324 14.313C30.8855 14.9722 31.1663 15.8877 31.1663 17.0596V17.7114ZM29.5256 16.5103C29.5207 15.8999 29.3767 15.4263 29.0935 15.0894C28.8103 14.7476 28.4197 14.5767 27.9216 14.5767C27.4333 14.5767 27.0183 14.7549 26.6765 15.1113C26.3396 15.4678 26.1321 15.9341 26.0539 16.5103H29.5256ZM38.3017 21H36.6538V19.8281H36.6245C36.1069 20.7266 35.3476 21.1758 34.3467 21.1758C33.6094 21.1758 33.0307 20.9756 32.6108 20.5752C32.1958 20.1748 31.9883 19.645 31.9883 18.9858C31.9883 17.5698 32.8037 16.7446 34.4346 16.5103L36.6611 16.1953C36.6611 15.126 36.1533 14.5913 35.1377 14.5913C34.2441 14.5913 33.4385 14.8989 32.7207 15.5142V14.0273C33.5117 13.5586 34.4248 13.3242 35.4599 13.3242C37.3545 13.3242 38.3017 14.2568 38.3017 16.1221V21ZM36.6611 17.3159L35.0864 17.5356C34.5981 17.5991 34.2295 17.7188 33.9804 17.8945C33.7363 18.0654 33.6142 18.3682 33.6142 18.8027C33.6142 19.1201 33.7265 19.3813 33.9512 19.5864C34.1806 19.7866 34.4858 19.8867 34.8667 19.8867C35.3843 19.8867 35.8115 19.7061 36.1484 19.3447C36.4902 18.9785 36.6611 18.5195 36.6611 17.9678V17.3159ZM46.9607 21H45.2614V19.7256H45.2321C44.6853 20.6924 43.843 21.1758 42.7053 21.1758C41.7824 21.1758 41.0427 20.8413 40.4861 20.1724C39.9343 19.4985 39.6584 18.583 39.6584 17.4258C39.6584 16.1855 39.9636 15.1919 40.5739 14.4448C41.1892 13.6978 42.0071 13.3242 43.0276 13.3242C44.0383 13.3242 44.7732 13.7295 45.2321 14.54H45.2614V9.89648H46.9607V21ZM45.2834 17.5723V16.5908C45.2834 16.0586 45.1101 15.6069 44.7634 15.2358C44.4167 14.8647 43.9748 14.6792 43.4377 14.6792C42.8029 14.6792 42.3025 14.916 41.9363 15.3896C41.5749 15.8633 41.3943 16.52 41.3943 17.3599C41.3943 18.1216 41.5676 18.7246 41.9143 19.1689C42.2658 19.6084 42.737 19.8281 43.3279 19.8281C43.9089 19.8281 44.3801 19.6157 44.7414 19.1909C45.1028 18.7612 45.2834 18.2217 45.2834 17.5723ZM64.0441 21H62.3449V16.9131C62.3449 16.127 62.2326 15.5581 62.008 15.2065C61.7883 14.855 61.4147 14.6792 60.8874 14.6792C60.4431 14.6792 60.0646 14.9014 59.7521 15.3457C59.4445 15.79 59.2907 16.3223 59.2907 16.9424V21H57.5842V16.7739C57.5842 15.3774 57.091 14.6792 56.1047 14.6792C55.6457 14.6792 55.2673 14.8892 54.9694 15.3091C54.6765 15.729 54.53 16.2734 54.53 16.9424V21H52.8308V13.5H54.53V14.6865H54.5593C55.1013 13.7783 55.8898 13.3242 56.925 13.3242C57.4426 13.3242 57.8942 13.4683 58.28 13.7563C58.6706 14.0396 58.9367 14.4131 59.0783 14.877C59.635 13.8418 60.465 13.3242 61.5686 13.3242C63.2189 13.3242 64.0441 14.3423 64.0441 16.3784V21ZM69.2021 21.1758C68.0449 21.1758 67.1196 20.8267 66.4262 20.1284C65.7377 19.4253 65.3935 18.4951 65.3935 17.3379C65.3935 16.0781 65.7524 15.0942 66.4702 14.3862C67.1928 13.6782 68.1645 13.3242 69.3852 13.3242C70.5571 13.3242 71.4702 13.6685 72.1245 14.3569C72.7788 15.0454 73.1059 16 73.1059 17.2207C73.1059 18.417 72.7519 19.3765 72.0439 20.0991C71.3408 20.8169 70.3935 21.1758 69.2021 21.1758ZM69.2827 14.6792C68.6186 14.6792 68.0937 14.9111 67.708 15.375C67.3222 15.8389 67.1293 16.4785 67.1293 17.2939C67.1293 18.0801 67.3246 18.7002 67.7153 19.1543C68.1059 19.6035 68.6284 19.8281 69.2827 19.8281C69.9516 19.8281 70.4643 19.606 70.8207 19.1616C71.1821 18.7173 71.3627 18.085 71.3627 17.2646C71.3627 16.4395 71.1821 15.8022 70.8207 15.353C70.4643 14.9038 69.9516 14.6792 69.2827 14.6792ZM81.4206 21H79.7214V19.7256H79.6921C79.1452 20.6924 78.3029 21.1758 77.1652 21.1758C76.2424 21.1758 75.5026 20.8413 74.946 20.1724C74.3942 19.4985 74.1183 18.583 74.1183 17.4258C74.1183 16.1855 74.4235 15.1919 75.0339 14.4448C75.6491 13.6978 76.467 13.3242 77.4875 13.3242C78.4982 13.3242 79.2331 13.7295 79.6921 14.54H79.7214V9.89648H81.4206V21ZM79.7433 17.5723V16.5908C79.7433 16.0586 79.57 15.6069 79.2233 15.2358C78.8766 14.8647 78.4347 14.6792 77.8976 14.6792C77.2629 14.6792 76.7624 14.916 76.3962 15.3896C76.0348 15.8633 75.8542 16.52 75.8542 17.3599C75.8542 18.1216 76.0275 18.7246 76.3742 19.1689C76.7258 19.6084 77.197 19.8281 77.7878 19.8281C78.3688 19.8281 78.84 19.6157 79.2013 19.1909C79.5627 18.7612 79.7433 18.2217 79.7433 17.5723ZM89.7499 17.7114H84.6376C84.6572 18.4048 84.8696 18.9395 85.2748 19.3154C85.685 19.6914 86.2465 19.8794 86.9594 19.8794C87.7602 19.8794 88.495 19.6401 89.164 19.1616V20.5312C88.4804 20.9609 87.5771 21.1758 86.454 21.1758C85.3505 21.1758 84.4838 20.8364 83.8539 20.1577C83.2289 19.4741 82.9164 18.5146 82.9164 17.2793C82.9164 16.1123 83.2607 15.1626 83.9491 14.4302C84.6425 13.6929 85.5019 13.3242 86.5273 13.3242C87.5527 13.3242 88.3461 13.6538 88.9076 14.313C89.4692 14.9722 89.7499 15.8877 89.7499 17.0596V17.7114ZM88.1093 16.5103C88.1044 15.8999 87.9604 15.4263 87.6772 15.0894C87.394 14.7476 87.0033 14.5767 86.5053 14.5767C86.017 14.5767 85.602 14.7549 85.2602 15.1113C84.9233 15.4678 84.7157 15.9341 84.6376 16.5103H88.1093Z" fill="white" />
                                </svg>

                            }

                            {this.state.recordMode &&
                                <svg width="235" height="30" viewBox="0 0 219 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="120" height="30" rx="15" fill="#F2F2F2"></rect>
                                    <path d="M24.4116 21H22.3755L20.6982 18.1875C20.5469 17.9287 20.3979 17.709 20.2515 17.5283C20.1099 17.3428 19.9634 17.1914 19.812 17.0742C19.6655 16.957 19.5044 16.8716 19.3286 16.8179C19.1528 16.7642 18.9551 16.7373 18.7354 16.7373H18.0322V21H16.2964V10.4971H19.7534C20.2466 10.4971 20.7007 10.5557 21.1157 10.6729C21.5308 10.79 21.8921 10.9683 22.1997 11.2075C22.5073 11.4419 22.7466 11.7373 22.9175 12.0938C23.0933 12.4453 23.1812 12.8579 23.1812 13.3315C23.1812 13.7026 23.125 14.0444 23.0127 14.3569C22.9053 14.6646 22.749 14.9404 22.5439 15.1846C22.3438 15.4238 22.0996 15.6289 21.8115 15.7998C21.5283 15.9707 21.2085 16.1025 20.8521 16.1953V16.2246C21.0425 16.332 21.2085 16.4517 21.3501 16.5835C21.4917 16.7104 21.626 16.8423 21.7529 16.979C21.8799 17.1157 22.0044 17.272 22.1265 17.4478C22.2534 17.6187 22.3926 17.8188 22.5439 18.0483L24.4116 21ZM18.0322 11.9106V15.3237H19.4824C19.751 15.3237 19.9976 15.2822 20.2222 15.1992C20.4517 15.1162 20.6494 14.9966 20.8154 14.8403C20.9814 14.6841 21.1108 14.4937 21.2036 14.269C21.2964 14.0444 21.3428 13.793 21.3428 13.5146C21.3428 13.0117 21.1841 12.6187 20.8667 12.3354C20.5493 12.0522 20.0928 11.9106 19.4971 11.9106H18.0322ZM31.1663 17.7114H26.0539C26.0735 18.4048 26.2859 18.9395 26.6912 19.3154C27.1013 19.6914 27.6628 19.8794 28.3757 19.8794C29.1765 19.8794 29.9114 19.6401 30.5803 19.1616V20.5312C29.8967 20.9609 28.9934 21.1758 27.8704 21.1758C26.7668 21.1758 25.9001 20.8364 25.2703 20.1577C24.6453 19.4741 24.3328 18.5146 24.3328 17.2793C24.3328 16.1123 24.677 15.1626 25.3655 14.4302C26.0588 13.6929 26.9182 13.3242 27.9436 13.3242C28.969 13.3242 29.7624 13.6538 30.324 14.313C30.8855 14.9722 31.1663 15.8877 31.1663 17.0596V17.7114ZM29.5256 16.5103C29.5207 15.8999 29.3767 15.4263 29.0935 15.0894C28.8103 14.7476 28.4197 14.5767 27.9216 14.5767C27.4333 14.5767 27.0183 14.7549 26.6765 15.1113C26.3396 15.4678 26.1321 15.9341 26.0539 16.5103H29.5256ZM38.3017 21H36.6538V19.8281H36.6245C36.1069 20.7266 35.3476 21.1758 34.3467 21.1758C33.6094 21.1758 33.0307 20.9756 32.6108 20.5752C32.1958 20.1748 31.9883 19.645 31.9883 18.9858C31.9883 17.5698 32.8037 16.7446 34.4346 16.5103L36.6611 16.1953C36.6611 15.126 36.1533 14.5913 35.1377 14.5913C34.2441 14.5913 33.4385 14.8989 32.7207 15.5142V14.0273C33.5117 13.5586 34.4248 13.3242 35.4599 13.3242C37.3545 13.3242 38.3017 14.2568 38.3017 16.1221V21ZM36.6611 17.3159L35.0864 17.5356C34.5981 17.5991 34.2295 17.7188 33.9804 17.8945C33.7363 18.0654 33.6142 18.3682 33.6142 18.8027C33.6142 19.1201 33.7265 19.3813 33.9512 19.5864C34.1806 19.7866 34.4858 19.8867 34.8667 19.8867C35.3843 19.8867 35.8115 19.7061 36.1484 19.3447C36.4902 18.9785 36.6611 18.5195 36.6611 17.9678V17.3159ZM46.9607 21H45.2614V19.7256H45.2321C44.6853 20.6924 43.843 21.1758 42.7053 21.1758C41.7824 21.1758 41.0427 20.8413 40.4861 20.1724C39.9343 19.4985 39.6584 18.583 39.6584 17.4258C39.6584 16.1855 39.9636 15.1919 40.5739 14.4448C41.1892 13.6978 42.0071 13.3242 43.0276 13.3242C44.0383 13.3242 44.7732 13.7295 45.2321 14.54H45.2614V9.89648H46.9607V21ZM45.2834 17.5723V16.5908C45.2834 16.0586 45.1101 15.6069 44.7634 15.2358C44.4167 14.8647 43.9748 14.6792 43.4377 14.6792C42.8029 14.6792 42.3025 14.916 41.9363 15.3896C41.5749 15.8633 41.3943 16.52 41.3943 17.3599C41.3943 18.1216 41.5676 18.7246 41.9143 19.1689C42.2658 19.6084 42.737 19.8281 43.3279 19.8281C43.9089 19.8281 44.3801 19.6157 44.7414 19.1909C45.1028 18.7612 45.2834 18.2217 45.2834 17.5723ZM64.0441 21H62.3449V16.9131C62.3449 16.127 62.2326 15.5581 62.008 15.2065C61.7883 14.855 61.4147 14.6792 60.8874 14.6792C60.4431 14.6792 60.0646 14.9014 59.7521 15.3457C59.4445 15.79 59.2907 16.3223 59.2907 16.9424V21H57.5842V16.7739C57.5842 15.3774 57.091 14.6792 56.1047 14.6792C55.6457 14.6792 55.2673 14.8892 54.9694 15.3091C54.6765 15.729 54.53 16.2734 54.53 16.9424V21H52.8308V13.5H54.53V14.6865H54.5593C55.1013 13.7783 55.8898 13.3242 56.925 13.3242C57.4426 13.3242 57.8942 13.4683 58.28 13.7563C58.6706 14.0396 58.9367 14.4131 59.0783 14.877C59.635 13.8418 60.465 13.3242 61.5686 13.3242C63.2189 13.3242 64.0441 14.3423 64.0441 16.3784V21ZM69.2021 21.1758C68.0449 21.1758 67.1196 20.8267 66.4262 20.1284C65.7377 19.4253 65.3935 18.4951 65.3935 17.3379C65.3935 16.0781 65.7524 15.0942 66.4702 14.3862C67.1928 13.6782 68.1645 13.3242 69.3852 13.3242C70.5571 13.3242 71.4702 13.6685 72.1245 14.3569C72.7788 15.0454 73.1059 16 73.1059 17.2207C73.1059 18.417 72.7519 19.3765 72.0439 20.0991C71.3408 20.8169 70.3935 21.1758 69.2021 21.1758ZM69.2827 14.6792C68.6186 14.6792 68.0937 14.9111 67.708 15.375C67.3222 15.8389 67.1293 16.4785 67.1293 17.2939C67.1293 18.0801 67.3246 18.7002 67.7153 19.1543C68.1059 19.6035 68.6284 19.8281 69.2827 19.8281C69.9516 19.8281 70.4643 19.606 70.8207 19.1616C71.1821 18.7173 71.3627 18.085 71.3627 17.2646C71.3627 16.4395 71.1821 15.8022 70.8207 15.353C70.4643 14.9038 69.9516 14.6792 69.2827 14.6792ZM81.4206 21H79.7214V19.7256H79.6921C79.1452 20.6924 78.3029 21.1758 77.1652 21.1758C76.2424 21.1758 75.5026 20.8413 74.946 20.1724C74.3942 19.4985 74.1183 18.583 74.1183 17.4258C74.1183 16.1855 74.4235 15.1919 75.0339 14.4448C75.6491 13.6978 76.467 13.3242 77.4875 13.3242C78.4982 13.3242 79.2331 13.7295 79.6921 14.54H79.7214V9.89648H81.4206V21ZM79.7433 17.5723V16.5908C79.7433 16.0586 79.57 15.6069 79.2233 15.2358C78.8766 14.8647 78.4347 14.6792 77.8976 14.6792C77.2629 14.6792 76.7624 14.916 76.3962 15.3896C76.0348 15.8633 75.8542 16.52 75.8542 17.3599C75.8542 18.1216 76.0275 18.7246 76.3742 19.1689C76.7258 19.6084 77.197 19.8281 77.7878 19.8281C78.3688 19.8281 78.84 19.6157 79.2013 19.1909C79.5627 18.7612 79.7433 18.2217 79.7433 17.5723ZM89.7499 17.7114H84.6376C84.6572 18.4048 84.8696 18.9395 85.2748 19.3154C85.685 19.6914 86.2465 19.8794 86.9594 19.8794C87.7602 19.8794 88.495 19.6401 89.164 19.1616V20.5312C88.4804 20.9609 87.5771 21.1758 86.454 21.1758C85.3505 21.1758 84.4838 20.8364 83.8539 20.1577C83.2289 19.4741 82.9164 18.5146 82.9164 17.2793C82.9164 16.1123 83.2607 15.1626 83.9491 14.4302C84.6425 13.6929 85.5019 13.3242 86.5273 13.3242C87.5527 13.3242 88.3461 13.6538 88.9076 14.313C89.4692 14.9722 89.7499 15.8877 89.7499 17.0596V17.7114ZM88.1093 16.5103C88.1044 15.8999 87.9604 15.4263 87.6772 15.0894C87.394 14.7476 87.0033 14.5767 86.5053 14.5767C86.017 14.5767 85.602 14.7549 85.2602 15.1113C84.9233 15.4678 84.7157 15.9341 84.6376 16.5103H88.1093Z" fill="#666666"></path>
                                    <rect x="100" width="121" height="30" rx="15" fill="#A850FF"></rect>
                                    <path d="M126.639 21H125.174L123.417 18.0557C123.255 17.7822 123.099 17.5503 122.948 17.3599C122.796 17.1646 122.64 17.0059 122.479 16.8838C122.323 16.7617 122.152 16.6738 121.966 16.6201C121.786 16.5615 121.581 16.5322 121.351 16.5322H120.34V21H119.11V10.4971H122.245C122.704 10.4971 123.126 10.5557 123.512 10.6729C123.902 10.7852 124.239 10.9585 124.523 11.1929C124.811 11.4272 125.035 11.7202 125.196 12.0718C125.358 12.4185 125.438 12.8262 125.438 13.2949C125.438 13.6611 125.382 13.998 125.27 14.3057C125.162 14.6084 125.006 14.8794 124.801 15.1187C124.601 15.3579 124.357 15.563 124.068 15.7339C123.785 15.8999 123.465 16.0293 123.109 16.1221V16.1514C123.285 16.2295 123.436 16.3198 123.563 16.4224C123.695 16.52 123.819 16.6372 123.937 16.7739C124.054 16.9106 124.169 17.0669 124.281 17.2427C124.398 17.4136 124.527 17.6138 124.669 17.8433L126.639 21ZM120.34 11.6104V15.4189H122.01C122.318 15.4189 122.601 15.3726 122.86 15.2798C123.124 15.187 123.351 15.0552 123.541 14.8843C123.732 14.7085 123.88 14.4961 123.988 14.2471C124.095 13.9932 124.149 13.71 124.149 13.3975C124.149 12.8359 123.966 12.3989 123.6 12.0864C123.238 11.769 122.713 11.6104 122.025 11.6104H120.34ZM133.277 17.5503H127.981C128.001 18.3853 128.225 19.0298 128.655 19.4839C129.085 19.938 129.676 20.165 130.428 20.165C131.272 20.165 132.049 19.8867 132.757 19.3301V20.458C132.098 20.9365 131.226 21.1758 130.142 21.1758C129.082 21.1758 128.25 20.8364 127.644 20.1577C127.039 19.4741 126.736 18.5146 126.736 17.2793C126.736 16.1123 127.066 15.1626 127.725 14.4302C128.389 13.6929 129.212 13.3242 130.193 13.3242C131.175 13.3242 131.934 13.6416 132.471 14.2764C133.008 14.9111 133.277 15.7925 133.277 16.9204V17.5503ZM132.046 16.5322C132.041 15.8389 131.873 15.2993 131.541 14.9136C131.214 14.5278 130.757 14.335 130.171 14.335C129.605 14.335 129.124 14.5376 128.728 14.9429C128.333 15.3481 128.089 15.8779 127.996 16.5322H132.046ZM139.973 20.6558C139.397 21.0024 138.713 21.1758 137.922 21.1758C136.853 21.1758 135.988 20.8291 135.329 20.1357C134.675 19.4375 134.348 18.5342 134.348 17.4258C134.348 16.1904 134.702 15.1992 135.41 14.4521C136.118 13.7002 137.063 13.3242 138.244 13.3242C138.903 13.3242 139.484 13.4463 139.987 13.6904V14.9209C139.431 14.5303 138.835 14.335 138.2 14.335C137.434 14.335 136.804 14.6108 136.311 15.1626C135.822 15.7095 135.578 16.4297 135.578 17.3232C135.578 18.2021 135.808 18.8955 136.267 19.4033C136.731 19.9111 137.351 20.165 138.127 20.165C138.781 20.165 139.397 19.9478 139.973 19.5132V20.6558ZM144.684 21.1758C143.576 21.1758 142.689 20.8267 142.025 20.1284C141.366 19.4253 141.036 18.4951 141.036 17.3379C141.036 16.0781 141.381 15.0942 142.069 14.3862C142.758 13.6782 143.688 13.3242 144.86 13.3242C145.978 13.3242 146.849 13.6685 147.474 14.3569C148.104 15.0454 148.419 16 148.419 17.2207C148.419 18.417 148.08 19.3765 147.401 20.0991C146.727 20.8169 145.822 21.1758 144.684 21.1758ZM144.772 14.335C144 14.335 143.39 14.5986 142.941 15.126C142.492 15.6484 142.267 16.3711 142.267 17.2939C142.267 18.1826 142.494 18.8833 142.948 19.396C143.402 19.9087 144.01 20.165 144.772 20.165C145.548 20.165 146.144 19.9136 146.559 19.4106C146.979 18.9077 147.189 18.1924 147.189 17.2646C147.189 16.3271 146.979 15.6045 146.559 15.0967C146.144 14.5889 145.548 14.335 144.772 14.335ZM154.009 14.7158C153.799 14.5547 153.497 14.4741 153.101 14.4741C152.588 14.4741 152.159 14.7158 151.812 15.1992C151.47 15.6826 151.299 16.3418 151.299 17.1768V21H150.098V13.5H151.299V15.0454H151.329C151.5 14.5181 151.761 14.1079 152.112 13.8149C152.464 13.5171 152.857 13.3682 153.292 13.3682C153.604 13.3682 153.843 13.4023 154.009 13.4707V14.7158ZM161.474 21H160.273V19.7256H160.244C159.687 20.6924 158.828 21.1758 157.666 21.1758C156.723 21.1758 155.969 20.8413 155.403 20.1724C154.841 19.4985 154.56 18.583 154.56 17.4258C154.56 16.1855 154.873 15.1919 155.498 14.4448C156.123 13.6978 156.955 13.3242 157.995 13.3242C159.026 13.3242 159.775 13.7295 160.244 14.54H160.273V9.89648H161.474V21ZM160.273 17.6089V16.5029C160.273 15.8975 160.073 15.3848 159.673 14.9648C159.272 14.5449 158.764 14.335 158.149 14.335C157.417 14.335 156.841 14.6035 156.421 15.1406C156.001 15.6777 155.791 16.4199 155.791 17.3672C155.791 18.2314 155.991 18.915 156.391 19.418C156.797 19.916 157.339 20.165 158.017 20.165C158.686 20.165 159.228 19.9233 159.643 19.4399C160.063 18.9565 160.273 18.3462 160.273 17.6089ZM178.192 21H176.991V16.6934C176.991 15.8633 176.861 15.2627 176.602 14.8916C176.348 14.5205 175.919 14.335 175.313 14.335C174.801 14.335 174.364 14.5693 174.002 15.0381C173.646 15.5068 173.468 16.0684 173.468 16.7227V21H172.266V16.5469C172.266 15.0723 171.698 14.335 170.56 14.335C170.033 14.335 169.598 14.5571 169.256 15.0015C168.914 15.4409 168.743 16.0146 168.743 16.7227V21H167.542V13.5H168.743V14.6865H168.773C169.305 13.7783 170.081 13.3242 171.102 13.3242C171.615 13.3242 172.061 13.4683 172.442 13.7563C172.823 14.0396 173.084 14.4131 173.226 14.877C173.783 13.8418 174.613 13.3242 175.716 13.3242C177.366 13.3242 178.192 14.3423 178.192 16.3784V21ZM183.357 21.1758C182.249 21.1758 181.362 20.8267 180.698 20.1284C180.039 19.4253 179.709 18.4951 179.709 17.3379C179.709 16.0781 180.054 15.0942 180.742 14.3862C181.431 13.6782 182.361 13.3242 183.533 13.3242C184.651 13.3242 185.522 13.6685 186.147 14.3569C186.777 15.0454 187.092 16 187.092 17.2207C187.092 18.417 186.753 19.3765 186.074 20.0991C185.4 20.8169 184.495 21.1758 183.357 21.1758ZM183.445 14.335C182.673 14.335 182.063 14.5986 181.614 15.126C181.165 15.6484 180.94 16.3711 180.94 17.2939C180.94 18.1826 181.167 18.8833 181.621 19.396C182.075 19.9087 182.683 20.165 183.445 20.165C184.221 20.165 184.817 19.9136 185.232 19.4106C185.652 18.9077 185.862 18.1924 185.862 17.2646C185.862 16.3271 185.652 15.6045 185.232 15.0967C184.817 14.5889 184.221 14.335 183.445 14.335ZM195.173 21H193.971V19.7256H193.942C193.386 20.6924 192.526 21.1758 191.364 21.1758C190.422 21.1758 189.667 20.8413 189.101 20.1724C188.539 19.4985 188.259 18.583 188.259 17.4258C188.259 16.1855 188.571 15.1919 189.196 14.4448C189.821 13.6978 190.654 13.3242 191.694 13.3242C192.724 13.3242 193.473 13.7295 193.942 14.54H193.971V9.89648H195.173V21ZM193.971 17.6089V16.5029C193.971 15.8975 193.771 15.3848 193.371 14.9648C192.97 14.5449 192.463 14.335 191.847 14.335C191.115 14.335 190.539 14.6035 190.119 15.1406C189.699 15.6777 189.489 16.4199 189.489 17.3672C189.489 18.2314 189.689 18.915 190.09 19.418C190.495 19.916 191.037 20.165 191.716 20.165C192.385 20.165 192.927 19.9233 193.342 19.4399C193.761 18.9565 193.971 18.3462 193.971 17.6089ZM203.392 17.5503H198.097C198.116 18.3853 198.341 19.0298 198.771 19.4839C199.2 19.938 199.791 20.165 200.543 20.165C201.388 20.165 202.164 19.8867 202.872 19.3301V20.458C202.213 20.9365 201.341 21.1758 200.257 21.1758C199.198 21.1758 198.365 20.8364 197.76 20.1577C197.154 19.4741 196.852 18.5146 196.852 17.2793C196.852 16.1123 197.181 15.1626 197.84 14.4302C198.504 13.6929 199.327 13.3242 200.309 13.3242C201.29 13.3242 202.049 13.6416 202.586 14.2764C203.124 14.9111 203.392 15.7925 203.392 16.9204V17.5503ZM202.162 16.5322C202.157 15.8389 201.988 15.2993 201.656 14.9136C201.329 14.5278 200.873 14.335 200.287 14.335C199.72 14.335 199.239 14.5376 198.844 14.9429C198.448 15.3481 198.204 15.8779 198.111 16.5322H202.162Z" fill="#ffffff"></path></svg>

                            }



                        </div>
                        } */}
                    </div>
                    <div className="wiki-container">
                        <div className="wiki-content-col-1">

                            <div style={{ position: "sticky", top: "100px", width: "525px" }}>
                              
                                {!this.state.recordMode &&
                                    (
                                        <React.Fragment>
                                            <PlayerWikiLayer
                                                selectedTextId={this.state.selectedTopicTextId}
                                                loggedInUser={this.props.loggedInUser}
                                                articleId={this.state.topicId}
                                                clickTransition={this.state.clickTransition}
                                                playFirst={this.playFirst}
                                                playPrevious={this.playPrevious}
                                                playbackEnded={this.playbackEnded}
                                                playNext={this.playNext}
                                                doesNextRecordingExist={this.doesNextRecordingExist}
                                                doesPrevRecordingExist={this.doesPrevRecordingExist}
                                                playLast={this.playLast}
                                                sectionSentences={this.state.sectionSentences}
                                                sentenceIndex={this.state.sentenceIndex}
                                                sectionIndex={this.state.sectionIndex}
                                                currRecording={this.state.currRecording}
                                                recordMode={this.state.recordMode}
                                                readNext={this.readNextVideo}
                                                sentenceVideos={this.state.sentenceVideos}

                                            />
                                            {(this.state.sentenceVideos && this.state.sentenceVideos.length == 0) &&
                                                <div className="videoBox listing" style={{ justifyContent: "unset", padding: "20px", marginTop: "10px" }}>
                                                    <div className="available-videos-header">No Videos Available. Be the first to record one!</div>
                                                </div>
                                            }
                                            {(this.state.sentenceVideos && this.state.sentenceVideos.length > 0) &&
                                                <div className="videoBox listing" style={{ justifyContent: "unset", padding: "20px", marginTop: "10px" }}>
                                                    <div className="available-videos-header">
                                                        <div>Videos</div>
                                                        <div style={{ fontWeight: "400" }}></div>
                                                    </div>
                                                    <div className="available-video-row" style={{height: "300px", overflow: "auto"}}>
                                                        {this.state.sentenceVideos.map((vid, vi) => {

                                                            return (
                                                                <div style={{ background: vid.isSelected ? "rgb(158, 212, 247)" : "white", borderRadius: vid.isSelected ? "10px" : "unset" }}
                                                                    onClick={() => {
                                                                        this.switchVideo(vid, vi);
                                                                    }} className="video-select-item video-listing-row">
                                                                    <div className="video-listing-item" style={{ width: "15%" }}>
                                                                        <svg width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="16" cy="16" r="16" fill="#CCCCCC" />
                                                                            <path d="M9.9754 14.3141C9.2014 15.0881 9.58828 15.8623 11.1365 17.4103C10.3625 16.6363 11.1365 15.4752 11.9105 15.4752C11.5236 14.701 11.1365 13.5399 9.9754 14.3141ZM12.6848 12.7659C11.5236 13.153 11.9108 14.3141 12.6848 15.4752C13.0719 15.4752 13.8459 15.4752 14.233 15.4752C14.233 15.4752 14.233 14.7012 14.233 14.3141C14.233 13.5399 14.233 12.3787 12.6848 12.7659ZM15.007 13.927V15.4752C16.1681 15.4752 18.4904 16.2492 20.0384 17.4103C20.0384 15.8621 20.4255 14.3141 20.8124 12.7659C21.1992 11.2176 21.9735 8.5085 22.3606 6.96026C22.7477 5.41202 20.8124 4.2509 20.0384 6.18626C19.6512 7.34738 18.1032 13.5399 17.7161 13.927C17.329 12.3787 16.555 8.12138 16.1679 5.79914C15.7808 3.86402 13.4585 4.2509 13.8456 6.18626C14.6199 10.8307 15.007 12.3787 15.007 13.927ZM19.6515 25.1511C20.8126 20.1197 21.5866 18.1843 16.5552 16.6363C15.007 16.2492 14.233 16.2492 13.8459 16.2492C12.6848 16.2492 11.5236 15.8621 11.5236 17.0232C11.5236 18.1843 13.4588 18.9583 15.007 18.9583C15.007 19.7323 15.007 22.8288 16.9421 23.9897H15.781C14.6199 22.8286 14.2328 21.6675 14.2328 19.7323C13.8456 19.7323 11.5234 18.9583 10.3623 17.4101C10.3623 19.7323 10.7494 23.6026 11.9105 25.1508C12.6845 26.3119 12.6845 26.6991 12.6845 27.4731H19.2641C19.2644 26.6993 19.2644 26.3122 19.6515 25.1511Z" fill="white" />
                                                                        </svg>
                                                                    </div>
                                                                    <div className="user-name" style={{ width: "40%" }}>{vid.user && vid.user.userName}</div>
                                                                    <div className="user-name" style={{ width: "30%" }}>{Moment(vid.date).format('MM-DD-YYYY')}</div>
                                                                    <div className="user-name" style={{ width: "15%" }}>

                                                                        <PlayCircleFilledRoundedIcon style={{ color: vid.isSelected ? "white" : "#6fc0f6" }} />


                                                                    </div>

                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            }
                                        </React.Fragment>
                                    )}
                            </div>
                        </div>
                        <div className="wiki-content-col-2">

                            <div className="wiki-content-top-row">
                                <div className="article-title">
                                    {this.state.articleTitle}
                                    <LocalMoviesRoundedIcon style={{ fontSize: "1.2em", color: "#0ebe0e", marginLeft: "20px", marginBottom: "6px" }} />
                                    {/* {(this.state.totalRecordings > 0) &&
                                        <React.Fragment>
                                            <LocalMoviesRoundedIcon style={{ fontSize: "1.2em", color: "#0ebe0e", marginLeft: "20px", marginBottom: "6px" }} />
                                            <span className="recordings-count-label">{this.state.totalRecordings} Recordings</span>
                                        </React.Fragment>
                                    }
                                    {(this.state.totalRecordings == 0) &&
                                        <React.Fragment>
                                            <LocalMoviesRoundedIcon style={{ fontSize: "1.2em", color: "#0ebe0e", marginLeft: "20px", marginBottom: "6px" }} />
                                            <span className="recordings-count-label">Be the first to record</span>
                                        </React.Fragment>
                                    } */}
                                </div>

                                {/* {!this.state.toggleWiki &&
                                    <div className="mode-toggle clickity" onClick={() => this.toggleWiki()}>
                                        <svg style={{ marginBottom: "3px" }} width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.7882 0C7.87906 0 2.8 3.32988 0 8C2.79765 12.6659 7.87435 16 13.7882 16C19.6979 16 24.7765 12.6701 27.5765 8C24.7784 3.33412 19.7021 0 13.7882 0ZM19.9059 8C19.9059 11.3882 17.1765 14.1176 13.7882 14.1176C10.4 14.1176 7.67059 11.3882 7.67059 8C7.67059 4.61176 10.4 1.88235 13.7882 1.88235C17.1765 1.88235 19.9059 4.61176 19.9059 8ZM2.21176 8C2.87059 7.10588 4.47059 5.12941 7.05882 3.67059C6.25882 4.94118 5.78824 6.4 5.78824 8C5.78824 9.6 6.25882 11.0588 7.05882 12.3294C4.51765 10.8706 2.87059 8.89412 2.21176 8ZM20.5176 12.3294C21.3176 11.0588 21.7882 9.6 21.7882 8C21.7882 6.4 21.3176 4.94118 20.5176 3.67059C23.0588 5.12941 24.7059 7.10588 25.3647 8C24.7059 8.89412 23.0588 10.8706 20.5176 12.3294ZM10.9647 8C10.9647 6.44706 12.2353 5.17647 13.7882 5.17647C15.3412 5.17647 16.6118 6.44706 16.6118 8C16.6118 9.55294 15.3412 10.8235 13.7882 10.8235C12.2353 10.8235 10.9647 9.55294 10.9647 8Z" fill="#697777" />
                                        </svg>
                                        <span className="expand-wiki">Show full wiki</span>
                                    </div>
                                } */}
                            </div>
                            <div>
                                <span style={{ marginRight: "30px"}}>Having problems with this content?</span>
                                <a target="_blank" href="https://forms.office.com/r/FxqWu8DHaC">Please let us know</a>
                            </div>
                            <div className="mode-toggle">
                                <span className="article-label">{this.state.url && "Article "}</span>
                                <span className="article-url">{this.state.url && <a href={this.state.url} target="_blank">{this.state.url}</a>}</span>
                            </div>
                            <div>
                                All text content is multi-licensed under the
                                <a href="https://en.wikipedia.org/wiki/Wikipedia:Text_of_Creative_Commons_Attribution-ShareAlike_3.0_Unported_License"> Creative Commons Attribution-ShareAlike 3.0 License</a> (CC-BY-SA) and the
                                <a href="https://en.wikipedia.org/wiki/Wikipedia:Text_of_the_GNU_Free_Documentation_License"> GNU Free Documentation License </a> (GFDL).
                            </div>
                            <div className="article-body" style={{ display: "flex", flexDirection: "row" }}>
                                <div style={{ minWidth: "60%" }}>
                                    {this.state.formattedSentences}
                                </div>
                                {this.state.toggleWiki &&
                                    <div>
                                        <div className="wiki-hider-cont" onClick={() => this.toggleWiki()}>
                                            <svg style={{ marginBottom: "3px" }} width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.7882 0C7.87906 0 2.8 3.32988 0 8C2.79765 12.6659 7.87435 16 13.7882 16C19.6979 16 24.7765 12.6701 27.5765 8C24.7784 3.33412 19.7021 0 13.7882 0ZM19.9059 8C19.9059 11.3882 17.1765 14.1176 13.7882 14.1176C10.4 14.1176 7.67059 11.3882 7.67059 8C7.67059 4.61176 10.4 1.88235 13.7882 1.88235C17.1765 1.88235 19.9059 4.61176 19.9059 8ZM2.21176 8C2.87059 7.10588 4.47059 5.12941 7.05882 3.67059C6.25882 4.94118 5.78824 6.4 5.78824 8C5.78824 9.6 6.25882 11.0588 7.05882 12.3294C4.51765 10.8706 2.87059 8.89412 2.21176 8ZM20.5176 12.3294C21.3176 11.0588 21.7882 9.6 21.7882 8C21.7882 6.4 21.3176 4.94118 20.5176 3.67059C23.0588 5.12941 24.7059 7.10588 25.3647 8C24.7059 8.89412 23.0588 10.8706 20.5176 12.3294ZM10.9647 8C10.9647 6.44706 12.2353 5.17647 13.7882 5.17647C15.3412 5.17647 16.6118 6.44706 16.6118 8C16.6118 9.55294 15.3412 10.8235 13.7882 10.8235C12.2353 10.8235 10.9647 9.55294 10.9647 8Z" fill="#697777" />
                                            </svg>
                                            <span className="expand-wiki">Hide Wiki</span>
                                        </div>
                                        <div className="wiki-content-box">
                                            <div>
                                                <div className="wikiHTML" dangerouslySetInnerHTML={{ __html: this.state.wikiContent }} />
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>

                    </div>

                </div>
            </React.Fragment>
        )
    }

}

const mapDispatchToProps = (dispatch) => ({
    updateScore,
    populateStore,
    requestFailedModal,
    dispatch
});

const Wikipedia = connect(

    mapDispatchToProps
)(WikiContainer);


export default Wikipedia
